export default __webpack_public_path__ + "static/medl-f5428498e53cb2ad1f4340ca1eeea846.jpg";